import {createSlice} from "@reduxjs/toolkit";
import {getProfileSuccess} from "store/reducer/user/profile/reducer";

export const initialState = {
    data: {}
}

const slice = createSlice({
    name: "userSettings",
    initialState,
    reducers: {
        setProfileSettingsStart: (state, {payload}) => {
            const {key, value} = payload;
            state.data[key] = value;
        },
        setProfileSettingsFailure: (state, {payload}) => {
            const {key, value} = payload;
            state.data[key] = value;
        }
    },
    extraReducers: {
        [getProfileSuccess]: (state, {payload}) => {
            state.data = {
                ...payload.settings
            }
        }
    }
});
const {reducer, actions} = slice;
export const {
    setProfileSettingsStart,
     setProfileSettingsFailure
} = actions;
export default reducer;